import { render } from "./DbaContainer.vue?vue&type=template&id=02d0fe6f"
import script from "./DbaContainer.vue?vue&type=script&lang=js"
export * from "./DbaContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__